export default __webpack_public_path__ + "static/service_usage-6fab5b6fe6376f5e6d141b56a918809c.png";